import { useEffect, useState } from 'react';
import { getWindowDimensions } from '../utilis/helpers';
import { getPrefetchedMediaSrc } from '../utilis/session-media-cache';

// for get window size when change
export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    clientWindowHeight: windowDimensions.height,
    clientWindowWidth: windowDimensions.width,
  };
};

/**
 * Resolves to a prefetched `blob:` URL when `url` was warmed ahead of time
 * (see camera-permission's prefetchSessionMedia call / utilis/session-media-cache.js)
 * and hasn't expired yet — otherwise resolves to `url` itself unchanged, so
 * callers never need a separate fallback path. Same `<img>`/`<video>` either
 * way, just served from a local blob instead of the network when it hits.
 */
export const usePrefetchedMediaSrc = url => {
  const [resolvedSrc, setResolvedSrc] = useState(url);

  useEffect(() => {
    let objectUrl = null;
    let cancelled = false;

    setResolvedSrc(url);

    if (!url) {
      return undefined;
    }

    getPrefetchedMediaSrc(url).then(cachedSrc => {
      if (cancelled || !cachedSrc) {
        return;
      }
      objectUrl = cachedSrc;
      setResolvedSrc(cachedSrc);
    });

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url]);

  return resolvedSrc;
};
